<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'App',
  mounted () {
    const token = localStorage.getItem('token');
    if (!token) {
      const redirectTo = window.location.href;

      if (!redirectTo.includes('login')) {
        this.$router.push({
          name: 'Login',
          query: {
            redirectTo,
          },
        });
      } else {
        this.$router.push({ name: 'Login' });
      }
    } else {
      api.api.interceptors.response.use(
        (conf) => conf,
        async (error) => {
          // If any api request returns status of 401 redirect it to login
          if (error.response.status === 401) {
            // if (this.$route.name !== 'LogOut') {
            //   this.$router.push({ name: 'LogOut' });
            // }

            localStorage.removeItem('token');
            const redirectTo = window.location.href;

            if (!redirectTo.includes('login')) {
              this.$router.push({
                name: 'Login',
                query: {
                  redirectTo,
                },
              });
            }
            return Promise.reject(error);
          }
          return Promise.reject(error);
        },
      );
    }
  },
};
</script>
<style>
.tox-promotion {
  display: none;
}
</style>